import { render, staticRenderFns } from "./QueryPagination.vue?vue&type=template&id=f4860a64&"
import script from "./QueryPagination.vue?vue&type=script&lang=ts&"
export * from "./QueryPagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports